export const realtorData = {
  // email: 'contacto@unne.cl',
  email:'info@unne.cl',
  // email: 'fabians@bidata.cl',
};
